module.exports = __webpack_public_path__ + "img/Article_forest.4c399190.jpg";